import set from "@rill/set";
import moment from "moment";
import PersonalRecordTable from "./PersonalRecordTable";
import _ from "lodash";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const {
  PRIMARIES,
  DATE_FORMATS: { DATE_PICKER_FORMAT, DATE_DAY_FORMAT },
} = require("../../../constants");

const PersonalRecordController = (app) => {
  app.get(
    "/personal-record",
    set("heading", "Personal Record Table"),
    async ({ req, res, load, locals }) => {
      const { query } = req;

      const { from, to, primary, type, secondary, athlete } = query;

      const athleteId = locals.athlete
        ? locals.athlete._id
        : locals.activeUser._id;

      const isAllowToViewAllOrganizationsAthletes =
        locals.organizationRoleName &&
        (locals.organizationRoleName === "Owner" ||
          locals.organizationRoleName === "Admin");

      const loadPromises = [];
      if (
        locals.activeUser.organizationId &&
        isAllowToViewAllOrganizationsAthletes &&
        !locals.allAthletesFromOrganization
      ) {
        loadPromises.push(load("allAthletesFromOrganization"));
      }

      //endpoint to load the the data on specific exercises
      loadPromises.push(
        load("exerciseHistory", {
          primary: primary ? primary : "squat",
          type: type ? type : "primary",
          secondary: secondary ? secondary : "",
          proxyAthlete: athleteId,
          from: from
            ? moment.utc(from).toDate()
            : moment.utc(moment().subtract(6, "months")).toDate(),
          to: to ? moment.utc(to).toDate() : moment.utc(moment()).toDate(),
        }),
        //endpoint to load the data on all the exercises
        load("exercisesRecordsLoadWithAssistants", {
          start: moment.utc("2015-12-31T07:57:45.121Z").toDate(), //date when MSB starts
          end: moment.utc(moment()).toDate(),
          proxyAthlete: athlete,
          reqSource: "metrics",
        })
      );

      await Promise.all(loadPromises);
      const modal = _.get(req.query, "modal", {});
      locals.modal = {
        "activity-feed": <ActivityDrawer />,
      }[modal.type];
      res.body = <PersonalRecordTable locals={locals} />;
    }
  );
};

export default PersonalRecordController;
